import { get_session9cytjmfbg8nd as get_session } from '../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  FileDataw8niis0ucpno as FileData,
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
} from '../../files/attachmentFilePreview.mjs';
import { modify3tvoxz8jo60p8 as modify } from '../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation } from '../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../nav/crowpay.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../../dialogs/GenericConfirmationDialog.mjs';
import { ViewSettlementDocs1y21duy3panzg as ViewSettlementDocs } from './ViewSettlementDocs.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { navigateTo251lpwmg2lk0y as navigateTo } from '../../../../utils/utils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { assert1ckwbdkg35i20 as assert } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import {
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../../theming/Titles.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../../theming/banners.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  divkhq3vjih9fcw as div,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../theming/colorManagement.mjs';
import { validategsg6go7eyi9d as validate } from '../../../../utils/validation.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { fileCarousely0kamh1gns47 as fileCarousel } from '../../files/fileManager.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.wh1_1.xgb(LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().sfg_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.xh1_1 = p0;
      }
      sao($completion) {
        return this.xh1_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ProjectSettlementDocumentationLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = requestFiles($this.yh1_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var preview = new (LocalFile())(item);
    var tmp_0 = modify($this.zh1_1.gh2_1, UploadSettlementDocsDialog$render$slambda$slambda_0(preview), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = async($this.yh1_1, VOID, VOID, UploadSettlementDocsDialog$render$slambda$slambda_2(preview));
    destination.v(tmp$ret$0);
  }
  var tmp_1 = awaitAll(destination, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var UploadSettlementDocsDialog$render$slambda$slambdaClass;
function UploadSettlementDocsDialog$render$slambda$slambda() {
  if (UploadSettlementDocsDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor($preview) {
        this.ih2_1 = $preview;
      }
      oge(it, $completion) {
        return plus(it, new (FileData())(VOID, Signal().fak(''), this.ih2_1, this.ih2_1));
      }
      s2(p1, $completion) {
        return this.oge((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UploadSettlementDocsDialog$render$slambda$slambdaClass = $;
  }
  return UploadSettlementDocsDialog$render$slambda$slambdaClass;
}
function UploadSettlementDocsDialog$render$slambda$slambda_0($preview) {
  var i = new (UploadSettlementDocsDialog$render$slambda$slambda())($preview);
  var l = (it, $completion) => i.oge(it, $completion);
  l.$arity = 1;
  return l;
}
var UploadSettlementDocsDialog$render$slambda$slambdaClass_0;
function UploadSettlementDocsDialog$render$slambda$slambda_1() {
  if (UploadSettlementDocsDialog$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($preview) {
        this.wh1_1 = $preview;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UploadSettlementDocsDialog$render$slambda$slambdaClass_0 = $;
  }
  return UploadSettlementDocsDialog$render$slambda$slambdaClass_0;
}
function UploadSettlementDocsDialog$render$slambda$slambda_2($preview) {
  var i = new (UploadSettlementDocsDialog$render$slambda$slambda_1())($preview);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jh2_1.gh2_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var files = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var session = tmp_1;
  var tmp0_submitted = session.ufw();
  var tmp1_project = $this.jh2_1.ah2_1.x7a_1;
  var tmp2_summary = $this.jh2_1.fh2_1.f2();
  var tmp3_submittedByClient = $this.jh2_1.bh2_1.xgj();
  var tmp_2 = session.mfw_1.zen(new (ProjectSettlementDocumentation())(VOID, tmp1_project, tmp0_submitted, tmp3_submittedByClient, tmp2_summary, files), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  get_dialogStack().ugg();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.kh2_1.eh2_1.pat_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.kh2_1.hh2_1.mam(true);
    return Unit_instance;
  }
  $this.kh2_1.hh2_1.mam(false);
  confirmationDialog($this.lh2_1, 'Submit Settlement?', 'Stoze and the other party will be notified of this settlement submission. Stoze will verify the documents and process fund disbursement according to the decision. This may take several business days.', 'Submit', VOID, VOID, VOID, VOID, VOID, VOID, UploadSettlementDocsDialog$render$slambda$slambda_4($this.kh2_1));
  return Unit_instance;
}
var UploadSettlementDocsDialog$render$slambda$slambdaClass_1;
function UploadSettlementDocsDialog$render$slambda$slambda_3() {
  if (UploadSettlementDocsDialog$render$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.jh2_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambda$slambdaClass_1 = $;
  }
  return UploadSettlementDocsDialog$render$slambda$slambdaClass_1;
}
function UploadSettlementDocsDialog$render$slambda$slambda_4(this$0) {
  var i = new (UploadSettlementDocsDialog$render$slambda$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function UploadSettlementDocsDialog$files$lambda(it) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !it.i1();
}
var UploadSettlementDocsDialog$render$slambdaClass;
function UploadSettlementDocsDialog$render$slambda() {
  if (UploadSettlementDocsDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass;
}
function UploadSettlementDocsDialog$render$slambda_0() {
  var i = new (UploadSettlementDocsDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialog$render$slambdaClass_0;
function UploadSettlementDocsDialog$render$slambda_1() {
  if (UploadSettlementDocsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.mh2_1 = $$this$button;
        this.nh2_1 = this$0;
      }
      sao($completion) {
        if (get_viewIsNarrow(this.mh2_1)) {
          get_dialogStack().ugg();
          navigateTo(get_mainPageNavigator(this.mh2_1), new (ViewSettlementDocs())(this.nh2_1.ah2_1.x7a_1, this.nh2_1.bh2_1, this.nh2_1.ch2_1));
        } else {
          get_dialogStack().dbw(new (ViewSettlementDocs())(this.nh2_1.ah2_1.x7a_1, this.nh2_1.bh2_1, this.nh2_1.ch2_1));
        }
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_0 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_0;
}
function UploadSettlementDocsDialog$render$slambda_2($$this$button, this$0) {
  var i = new (UploadSettlementDocsDialog$render$slambda_1())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var UploadSettlementDocsDialog$render$slambdaClass_1;
function UploadSettlementDocsDialog$render$slambda_3() {
  if (UploadSettlementDocsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.yh1_1 = $$this$button;
        this.zh1_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_1 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_1;
}
function UploadSettlementDocsDialog$render$slambda_4($$this$button, this$0) {
  var i = new (UploadSettlementDocsDialog$render$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialog$render$slambdaClass_2;
function UploadSettlementDocsDialog$render$slambda_5() {
  if (UploadSettlementDocsDialog$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.kh2_1 = this$0;
        this.lh2_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_2 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_2;
}
function UploadSettlementDocsDialog$render$slambda_6(this$0, $$this$button) {
  var i = new (UploadSettlementDocsDialog$render$slambda_5())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialog$render$slambdaClass_3;
function UploadSettlementDocsDialog$render$slambda_7() {
  if (UploadSettlementDocsDialog$render$slambdaClass_3 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UploadSettlementDocsDialog$render$slambdaClass_3 = $;
  }
  return UploadSettlementDocsDialog$render$slambdaClass_3;
}
function UploadSettlementDocsDialog$render$slambda_8() {
  var i = new (UploadSettlementDocsDialog$render$slambda_7())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UploadSettlementDocsDialogClass;
function UploadSettlementDocsDialog() {
  if (UploadSettlementDocsDialogClass === VOID) {
    class $ {
      constructor(project, lens, source) {
        this.ah2_1 = project;
        this.bh2_1 = lens;
        this.ch2_1 = source;
        this.dh2_1 = 35;
        this.eh2_1 = new (IssueNode())();
        var tmp = this;
        var tmp_0 = validated(Signal().fak(''), this.eh2_1);
        var tmp_1 = 'Must be at least ' + this.dh2_1 + ' characters.';
        tmp.fh2_1 = assert(tmp_0, tmp_1, VOID, VOID, (it) => it.length >= this.dh2_1);
        var tmp_2 = this;
        var tmp_3 = validated(ReactiveMutableList().tam(), this.eh2_1);
        tmp_2.gh2_1 = assert(tmp_3, 'Required', VOID, VOID, UploadSettlementDocsDialog$files$lambda);
        this.hh2_1 = Signal().fak(false);
      }
      ud6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(UploadSettlementDocsDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp_0 = view.ibb(get_atTopCenter(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40)));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        var tmp0_vertical = get_rem(3);
        var tmp1_horizontal = get_rem(0);
        view_0.hba(Edges().cd0(tmp1_horizontal, tmp0_vertical));
        view_0.cb9(true);
        var tmp_1 = view_0.hbb(DialogSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        title(view_1, 'Settlement');
        var tmp_2 = view_1.ibb(shownWhen(view_1, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.baj(this.ch2_1.oh2()).i1();
        }), notificationBar(view_1, AppColors_getInstance().jfz_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        body(view_2, 'There are existing settlement documents, click here to view existing settlement documentation.');
        var tmp_3 = view_2.ibb(get_atEnd(view_2), get_secondaryButton(view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        specCenteredText(view_3, 'View Settlement Documents');
        onClick(view_3, VOID, VOID, UploadSettlementDocsDialog$render$slambda_2(view_3, this));
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_3, view_3);
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_2, view_2);
        body(view_1, 'Submit the results of arbitration, court decision, or notarized mutual agreement along with supporting documents. Include contact information for the issuing party. Stoze will verify the submission before processing fund disbursement.');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.ebb(p_4, view_4);
        view_4.xbm(true);
        view_4.zb8(div(view_4.kba().hb0_1, 2));
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xbm(false);
        view_6.zb8(get_AppDimensions().pg2_1);
        view_6.jbb(get_centered(view_6), bodyBold(view_6, 'Summary'));
        view_6.jbb(colored(view_6, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_6, '*'));
        view_5.fbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_4 = view_5.hbb(FieldSemantic_getInstance());
        var tmp_5 = sizeConstraints(view_5, VOID, VOID, get_rem(8));
        var tmp_6 = view_5.ibb(tmp_5, validate(view_5, this.fh2_1, ($this$validate) => $this$validate.baj(this.hh2_1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextArea())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.ebb(p_7, view_7);
        view_7.xah(view_7.qcl_1, this.fh2_1);
        view_7.tcl('Minimum ' + this.dh2_1 + ' characters');
        view_5.fbb(p_7, view_7);
        var tmp$ret$16 = view_5.jbb(tmp_6, view_7);
        view_5.jbb(tmp_4, tmp$ret$16);
        view_4.fbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_8 = view_4.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
        view_4.ebb(p_8, view_8);
        view_8.xbm(false);
        var tmp_7 = get_centered(view_8);
        var tmp_8 = get_issues(this.fh2_1);
        view_8.jbb(tmp_7, issueText(view_8, tmp_8, VOID, ($this$issueText) => $this$issueText.baj(this.hh2_1)));
        var tmp_9 = get_expanding(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Space())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        view_8.fbb(p_9, view_9);
        view_8.jbb(tmp_9, view_9);
        var tmp_10 = align(view_8, Align_End_getInstance(), Align_Center_getInstance());
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (TextView())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.ebb(p_10, view_10);
        view_10.jba(view_10.ob6_1.ybe(SmallBodySemantic_getInstance()));
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(view_10);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(view_10));
        reactiveScope(view_10, ($this$reactiveScope) => {
          var diff = this.dh2_1 - $this$reactiveScope.baj(this.fh2_1).length | 0;
          var tmp$ret$25 = diff > 0 ? '' + diff + ' characters remaining' : '';
          this_0.set(tmp$ret$25);
          return Unit_instance;
        });
        view_8.fbb(p_10, view_10);
        view_8.jbb(tmp_10, view_10);
        view_4.fbb(p_8, view_8);
        view_1.fbb(p_4, view_4);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Documents';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_11 = view_1.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_1 : tmp0_elvis_lhs_11;
        view_1.ebb(p_11, view_11);
        view_11.xbm(true);
        view_11.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.ebb(p_12, view_12);
        view_12.xbm(false);
        view_12.zb8(get_AppDimensions().pg2_1);
        view_12.jbb(get_centered(view_12), bodyBold(view_12, label));
        view_12.jbb(colored(view_12, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_12, '*'));
        view_11.fbb(p_12, view_12);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_13 = view_11.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_13 = view_11.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
        view_11.ebb(p_13, view_13);
        view_13.xbm(false);
        view_13.jbb(view_13.ibb(get_scrollingHorizontally(view_13), get_expanding(view_13)), fileCarousel(view_13, this.gh2_1, 'No Uploads Yet'));
        var tmp_14 = view_13.ibb(sizeConstraints(view_13, VOID, VOID, VOID, VOID, VOID, div(get_AppDimensions().qg2_1, 3)), get_tertiaryButton(view_13));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Button())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.ebb(p_14, view_14);
        view_14.jbb(get_centered(view_14), icon(view_14, Companion_getInstance().wcf_1, 'Add Files'));
        onClick(view_14, VOID, VOID, UploadSettlementDocsDialog$render$slambda_4(view_14, this));
        view_13.fbb(p_14, view_14);
        view_13.jbb(tmp_14, view_14);
        view_11.fbb(p_13, view_13);
        var tmp_15 = get_issues(this.gh2_1);
        var tmp$ret$52 = issueText(view_11, tmp_15, VOID, ($this$issueText) => $this$issueText.baj(this.hh2_1));
        view_11.jbb(tmp_13, tmp$ret$52);
        view_1.fbb(p_11, view_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_15 = view_1.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_1 : tmp0_elvis_lhs_15;
        view_1.ebb(p_15, view_15);
        view_15.xbm(false);
        view_15.zb8(get_AppDimensions().ig2_1);
        var tmp_16 = get_primaryButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.cbb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.ebb(p_16, view_16);
        specCenteredText(view_16, 'Submit Settlement');
        onClick(view_16, VOID, VOID, UploadSettlementDocsDialog$render$slambda_6(this, view_16));
        view_15.fbb(p_16, view_16);
        view_15.jbb(tmp_16, view_16);
        var tmp_17 = get_textButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_17 = view_15.cbb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
        view_15.ebb(p_17, view_17);
        specCenteredText(view_17, 'Go Back');
        onClick(view_17, VOID, VOID, UploadSettlementDocsDialog$render$slambda_8());
        view_15.fbb(p_17, view_17);
        view_15.jbb(tmp_17, view_17);
        view_1.fbb(p_15, view_15);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'UploadSettlementDocsDialog', VOID, VOID, [Page()]);
    UploadSettlementDocsDialogClass = $;
  }
  return UploadSettlementDocsDialogClass;
}
//region block: exports
export {
  UploadSettlementDocsDialog as UploadSettlementDocsDialog3j42xvchj1p9v,
};
//endregion

//# sourceMappingURL=UploadSettlementDocsDialog.mjs.map
